import { InvoiceCreate } from './InvoiceCreate';
import { InvoiceShow } from './InvoiceShow';

const Invoices = {
  create: InvoiceCreate,
  show: InvoiceShow,
};

export default Invoices;
